import * as React from 'react';
import { FormHelperText } from '@mui/material';

interface ElementDescriptionProps {
  children: React.ReactNode;
  error?: boolean;
}

const ElementDescription: React.FC<ElementDescriptionProps> = ({
  children,
  error = false,
}) => {
  return (
    <FormHelperText sx={{ marginLeft: 0, marginRight: 0 }} error={error}>
      {children}
    </FormHelperText>
  );
};

export default ElementDescription;
